module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/slider-scale.2d94412b.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXRewardsTank/components/TankAuctionSlider/images/slider-scale.png
// module id = 1050
// module chunks = 16